import React from "react";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import UploadExcelShipment from "../ShipmentComponents/UploadExcelShipment";

const ImportExcelShipmentCreateScreen = () => {
  const breadcrumbs = [
    {
      title: "Shipment",
      path: "/app/crm/shipment/list",
    },
    {
      title: "Import Excel Shipment",
    },
  ];

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs}>
      <BreadcrumbLayout.Paper>
        <UploadExcelShipment />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default ImportExcelShipmentCreateScreen;